module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg2NCAxMjhhMzIgMzIgMCAwIDEgMzIgMzJ2NzA0YTMyIDMyIDAgMCAxLTMyIDMySDE2MGEzMiAzMiAwIDAgMS0zMi0zMlYxNjBhMzIgMzIgMCAwIDEgMzItMzJoNzA0ek01MTIgMjg4YTMyIDMyIDAgMCAwLTMyIDMydjE2MGgtMTYwYTMyIDMyIDAgMCAwIDAgNjRoMTYwdjE2MGEzMiAzMiAwIDAgMCA2NCAwdi0xNjBoMTYwYTMyIDMyIDAgMCAwIDAtNjRoLTE2MHYtMTYwYTMyIDMyIDAgMCAwLTMyLTMyeiIgZmlsbD0iIzAiIHAtaWQ9IjMwODQiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Unfolded-filled.svg
// module id = FyMS
// module chunks = 74